import {
    ClientDetailModel,
    ClientEligibilityStatus,
    ClientProfileStatus,
} from 'lemunzo-api';

/**
 * An auxiliary function that produces a new instance of the generated ClientDetailModel,
 * with all fields assigned a form of a default value.
 */
export function getEmptyClientProfileModel(): ClientDetailModel {
    return {
        id: 0,
        phone: null,
        userLanguage: '',
        email: '',
        address: null,
        organization: null,
        person: null,
        status: ClientProfileStatus.ActionRequired,
        eligibilityStatus: ClientEligibilityStatus.Pending,
        isEditable: false,
        caseId: 0,
        totalRevenue: {
            value: 0,
            currency: 'EUR',
        },
        caseClientId: '',
        allEvidenceUploaded: false,
    };
}
